import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

/**
 * require.context是webpack的api
 * 接收三个参数：
 * directory：读取文件的地址
 * useSubdirectories：是否遍历文件的子目录
 * regExp：匹配文件的正则
 *
 * 返回一个函数，有3个属性
 * resolve：（function）返回这个匹配文件相对于证规工程的相对路径
 * keys：（function）返回匹配成功模块的名字组成的数组
 * id：（string）
 */
const modulesFiles = require.context('./modules', true, /\.js$/)

const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

export default new Vuex.Store({
  modules
})
